/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminBillAdminBillItem
 */
export interface AdminBillAdminBillItem {
    /**
     * 账单ID
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    userId?: number;
    /**
     * 账单类型
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    billType?: number;
    /**
     * 账单状态
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    status?: number;
    /**
     * 汇款人（持卡人姓名）
     * @type {string}
     * @memberof AdminBillAdminBillItem
     */
    cardHolderName?: string;
    /**
     * 卡号
     * @type {string}
     * @memberof AdminBillAdminBillItem
     */
    cardNumber?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof AdminBillAdminBillItem
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminBillAdminBillItem
     */
    userCode?: string;
    /**
     * 钱包转账总金额
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    totalTransferAmount?: number;
    /**
     * 卡类型
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    cardType?: number;
    /**
     * 卡所在银行名称
     * @type {string}
     * @memberof AdminBillAdminBillItem
     */
    cardBankName?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof AdminBillAdminBillItem
     */
    createTime?: string;
    /**
     * 仓库ID（订单创建账单时归属的仓库；钱包操作类账单为空）
     * @type {number}
     * @memberof AdminBillAdminBillItem
     */
    warehouseId?: number;
}

/**
 * Check if a given object implements the AdminBillAdminBillItem interface.
 */
export function instanceOfAdminBillAdminBillItem(value: object): value is AdminBillAdminBillItem {
    return true;
}

export function AdminBillAdminBillItemFromJSON(json: any): AdminBillAdminBillItem {
    return AdminBillAdminBillItemFromJSONTyped(json, false);
}

export function AdminBillAdminBillItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminBillAdminBillItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'billType': json['billType'] == null ? undefined : json['billType'],
        'status': json['status'] == null ? undefined : json['status'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'cardBankName': json['cardBankName'] == null ? undefined : json['cardBankName'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
    };
}

export function AdminBillAdminBillItemToJSON(json: any): AdminBillAdminBillItem {
    return AdminBillAdminBillItemToJSONTyped(json, false);
}

export function AdminBillAdminBillItemToJSONTyped(value?: AdminBillAdminBillItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'billType': value['billType'],
        'status': value['status'],
        'cardHolderName': value['cardHolderName'],
        'cardNumber': value['cardNumber'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'totalTransferAmount': value['totalTransferAmount'],
        'cardType': value['cardType'],
        'cardBankName': value['cardBankName'],
        'createTime': value['createTime'],
        'warehouseId': value['warehouseId'],
    };
}

